import { Outlet, createBrowserRouter } from "react-router-dom";
import React from "react";
import LoginPage from "./page/login/LoginPage";
import ErrorPage from "./page/404/ErrorPage";
import Home from "./page/Home/Home";
import ComHeader from "./Components/ComHeader/ComHeader";
import ComHeaderUser from "./Components/ComHeaderUser/ComHeaderUser";
import Checkout from "./page/Checkout";
import OrderHistory from "./page/OrderHistory/OrderHistory";
import ProfilePage from "./page/ProfileUser/ProfileUser";
import Register from "./page/Register/Register";
import RetreatsPage from "./page/Retreats/Retreats";
import RetreatDetail from "./page/RetreatDetail/RetreatDetail";
import RetreatAddUser from "./page/RetreatAddUser/RetreatAddUser";
import RetreatRegister from "./page/RetreatDetail/RetreatRegister";
import EnrolledCoursesPage from "./page/EnrolledCoursesPage/EnrolledCoursesPage";
import MenuFood from "./page/MenuFood/MenuFood";
import ChatApp from "./page/ChatApp/ChatApp";
import ForgotPassword from "./page/login/ForgotPassword";
import SuccessRegister from "./page/Register/SuccessRegister";
import Payment from "./page/Payment/Payment";
import About from "./page/About/About";
import DetailRetreats from "./page/DetailRetreats/DetailRetreats";
import InteractiveWeeklySchedule from "./page/WeeklySchedule/WeeklySchedule";
import MonasteryVisit from "./page/MonasteryVisit/MonasteryVisit";
import MonasteryGuidelines from "./page/MonasteryGuidelines/MonasteryGuidelines";
import ContactInformation from './page/ContactInformation/ContactInformation';
import AdminAccount from './page/Admin/AdminAccount/AdminAccount';
import AdminAddAccount from './page/Admin/AdminAccount/AdminAddAccount';
import AdminDetailAccount from './page/Admin/AdminAccount/AdminDetailAccount';
import AdminRoom from './page/Admin/AdminRoom/AdminRoom';
import AdminDetailRoom from './page/Admin/AdminRoom/AdminDetailRoom';
import AdminRetreat from './page/Admin/AdminRetreat/AdminRetreat';
import AdminAddRetreat from './page/Admin/AdminRetreat/AdminAddRetreat';
import AdminDetailRetreat from './page/Admin/AdminRetreat/AdminDetailRetreat';
import AdminTool from './page/Admin/AdminTool/AdminTool';
import AdminDetailTool from './page/Admin/AdminTool/AdminDetailTool';
import AdminToolHistory from './page/Admin/AdminToolHistory/AdminToolHistory';
import AdminLesson from "./page/Admin/AdminLesson/AdminLesson";
import AdminDetailLesson from "./page/Admin/AdminLesson/AdminDetailLesson";
import AdminDetailToolHistory from "./page/Admin/AdminToolHistory/AdminDetailToolHistory";
import AdminPayment from "./page/Admin/AdminPayment/AdminPayment";
import MonkWeeklySchedule from "./page/Monk/MonkSchedule/MonkWeeklySchedule";
import Certification from "./page/Certification/Certification";
import UserRefund from "./page/Refund/Refund";
import MonkMenuFood from "./page/Monk/MonkMenuFood/MonkMenuFood";
import MonkRetreatSchedule from "./page/Monk/MonkSchedule/MonkRetreatSchedule";
import MonkDish from "./page/Monk/MonkDish/MonkDish";
import MonkAddDish from "./page/Monk/MonkDish/MonkAddDish";
import MonkDetailDish from "./page/Monk/MonkDish/MonkDetailDish";
import ProtectedMonkRoute from "./utils/isMonk";
import ProtectedAdminRoute from "./utils/isAdmin";
import Forums from "./page/Forums/Forums";
import ForumDetail from "./page/Forums/ForumDetail";
import NotificationApi from "./Notification/NotificationApi";
import MyForums from "./page/Forums/MyForums";
import ChangePassword from "./page/Admin/ChangePassword/ChangePassword";
import Notifications from "./page/Notification/Notification";
import PaymentCancel from "./page/Payment/PaymentCancel";
import Offering from "./page/Offering/Offering";
import AdminGroup from "./page/Admin/AdminGroup/AdminGroup";
import AdminDetailGroup from "./page/Admin/AdminGroup/AdminDetailGroup";
import AdminDashBoard from "./page/Admin/AdminDashBoard/AdminDashBoard";

export const routers = createBrowserRouter([
  {
    path: "*",
    element: (
      <ComHeader>
        <ErrorPage />
      </ComHeader>
    ),
  },
  {
    path: "/",
    element: (
      <NotificationApi>
        <ComHeader>
          <Outlet />
        </ComHeader>
      </NotificationApi>
    ),
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/Contact",
        element: <ContactInformation />,
      },
      {
        path: "/About",
        element: <About />,
      },
      {
        path: "/Forums",
        element: <Forums />,
      },
      {
        path: "/Forums/:id",
        element: <ForumDetail />,
      },
      {
        path: "/MonasteryVisit",
        element: <MonasteryVisit />,
      },
      {
        path: "/Success-register/:id",
        element: <SuccessRegister />,
      },
      {
        path: "/payment-result",
        element: <Payment />,
      },
      {
        path: "/cancel-payment",
        element: <PaymentCancel />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/chat",
        element: <ChatApp />,
      },
      {
        path: "/offering",
        element: <Offering />,
      },
      {
        path: "/register",
        element: <Register />,
      },
      {
        path: "/retreat/add",
        element: <RetreatAddUser />,
      },
      {
        path: "/Notification",
        element: <Notifications />,
      },
      {
        path: "/Notification/:id",
        element: <Notifications />,
      },
      {
        path: "/retreats",
        element: <RetreatsPage />,
      },
      {
        path: "/retreat/:id",
        element: <RetreatDetail />,
      },
      {
        path: "/visitor-guide",
        element: <MonasteryGuidelines />,
      },
      {
        path: "/retreat/register/:id",
        element: <RetreatRegister />,
      },

      {
        path: "/user",
        element: (
          <ComHeaderUser>
            <Outlet />
          </ComHeaderUser>
        ),
        children: [
          {
            path: "/user/order-history",
            element: <OrderHistory />,
          },
          {
            path: "/user/course",
            element: <EnrolledCoursesPage />,
          },
          {
            path: "/user/course/:id",
            element: <DetailRetreats />,
          },
          {
            path: "/user/change-password",
            element: <ChangePassword />,
          },
          {
            path: "/user/Forums",
            element: <MyForums />,
          },
          {
            path: "/user/profile",
            element: <ProfilePage />,
          },
          {
            path: "/user/WeeklySchedule",
            element: <InteractiveWeeklySchedule />,
          },
          {
            path: "/user/MenuFood",
            element: <MenuFood />,
          },
          {
            path: "/user/Certification",
            element: <Certification />,
          },
          {
            path: "/user/Refund",
            element: <UserRefund />,
          },
        ],
      },
      {
        path: "/checkout",
        element: <Checkout />,
      },
    ],
  },
  {
    path: "/Admin",
    element: <ProtectedAdminRoute />,
    children: [
      {
        path: "/Admin/*",
        element: <ErrorPage />,
      },
      {
        path: "/Admin/Account",
        element: <AdminAccount />,
      },
      {
        path: "/Admin/Account/AddAccount",
        element: <AdminAddAccount />,
      },
      {
        path: "/Admin/Account/:id",
        element: <AdminDetailAccount />,
      },
      {
        path: "/Admin/Room",
        element: <AdminRoom />,
      },
      {
        path: "/Admin/Room/:id",
        element: <AdminDetailRoom />,
      },
      {
        path: "/Admin/Retreat",
        element: <AdminRetreat />,
      },
      {
        path: "/Admin/Retreat/AddRetreat",
        element: <AdminAddRetreat />,
      },
      {
        path: "/Admin/Retreat/:id",
        element: <AdminDetailRetreat />,
      },
      {
        path: "/Admin/Tool",
        element: <AdminTool />,
      },
      {
        path: "/Admin/Tool/:id",
        element: <AdminDetailTool />,
      },
      {
        path: "/Admin/ToolHistory",
        element: <AdminToolHistory />,
      },
      {
        path: "/Admin/ToolHistory/:id",
        element: <AdminDetailToolHistory />,
      },
      {
        path: "/Admin/Lesson",
        element: <AdminLesson />,
      },
      {
        path: "/Admin/Lesson/:id",
        element: <AdminDetailLesson />,
      },
      {
        path: "/Admin/Group",
        element: <AdminGroup />,
      },
      {
        path: "/Admin/Group/:id",
        element: <AdminDetailGroup />,
      },
      {
        path: "/Admin/Payment",
        element: <AdminPayment />,
      },
      {
        path: "/Admin/DashBoard",
        element: <AdminDashBoard />,
      },
      {
        path: "/Admin/chat",
        element: <ChatApp/>,
      },
    ],
  },
  {
    path: "/Monk",
    element: <ProtectedMonkRoute />,
    children: [
      {
        path: "/Monk/*",
        element: <ErrorPage />,
      },
      {
        path: "/Monk/Schedule",
        element: <MonkRetreatSchedule />,
      },
      {
        path: "/Monk/Schedule/:id",
        element: <MonkWeeklySchedule />,
      },
      {
        path: "/Monk/MenuFood",
        element: <MonkMenuFood />,
      },
      {
        path: "/Monk/Dish",
        element: <MonkDish />,
      },
      {
        path: "/Monk/Dish/:id",
        element: <MonkDetailDish />,
      },
      {
        path: "/Monk/chat",
        element: <ChatApp/>,
      },
    ],
  },
]);
